/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Specifies the paypal flow to use
 * @export
 */
export const PaypalIntent = {
    Capture: 'CAPTURE',
    Authorize: 'AUTHORIZE'
} as const;
export type PaypalIntent = typeof PaypalIntent[keyof typeof PaypalIntent];


export function PaypalIntentFromJSON(json: any): PaypalIntent {
    return PaypalIntentFromJSONTyped(json, false);
}

export function PaypalIntentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaypalIntent {
    return json as PaypalIntent;
}

export function PaypalIntentToJSON(value?: PaypalIntent | null): any {
    return value as any;
}

